<template>
	<div class="rejected-banner" v-if="visible">
		<p class="m-0">
			Has rechazado las cookies. Algunas funciones pueden no funcionar correctamente.
		</p>
		<PrimaryButton @click="acceptCookies">
			Aceptar cookies
		</PrimaryButton>
	</div>
</template>

<script>
import {cookieConsentBus, cookieManager} from "@/service/cookieManager";
import PrimaryButton from "@/components/ui/buttons/variants/PrimaryButton.vue";

export default {
	name: "RejectedCookiesBanner",
	components: {
		PrimaryButton,
	},
	data() {
		return {
			visible: false,
		};
	},
	methods: {
		handleConsentChange(event) {
			this.visible = event.detail === false;
		},
		checkConsent() {
			const consent = cookieManager.getCookie("cookies-accepted");
			this.visible = consent === "false";
		},
		acceptCookies() {
			cookieManager.setConsent(true);
			const token = localStorage.getItem("pending-token");
			if (token) {
				cookieManager.setToken(token);
				localStorage.removeItem("pending-token");
			}
			this.visible = false;
		}
	},
	mounted() {
		this.checkConsent();
		cookieConsentBus.addEventListener("consent-changed", this.handleConsentChange);
	},
	beforeUnmount() {
		cookieConsentBus.removeEventListener("consent-changed", this.handleConsentChange);
	},
};
</script>

<style scoped>
.rejected-banner {
	position: sticky;
	top: 0;
	width: 100%;
	background-color: #fff3cd;
	color: #856404;
	border-bottom: 1px solid #ffeeba;
	padding: 0.25rem;
	display: flex;
	flex-direction: column; /* Default para móviles */
	justify-content: center;
	align-items: center;
	gap: 0.5rem;
	z-index: 9999;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
	text-align: center;
	button.app-btn {
		width: 100%;
	}
}

/* A partir de 768px: layout horizontal */
@media (min-width: 768px) {
	.rejected-banner {
		flex-direction: row;
		text-align: left;

		button.app-btn {
			width: max-content;
		}
	}
}

</style>
